import React from "react";
import axios from "axios";
import parser from "xml2json-light";
import he from "he";
import { TimetableEntry } from "./timetableEnty";
import { startTime } from "./clock";
import { example } from "./exampleData";

import { extendObservable } from "mobx";
import { observer } from "mobx-react";

export default observer(
  class Timetable extends React.Component {
    constructor() {
      super();

      extendObservable(this, {
        online: true,
      });
    }

    state = {
      journeys: [],
      // online: true,
    };

    getData = () => {
      // if offline skip download new data
      if (!this.online) {
        console.log("skip fetch because offline");
        return;
      }

      //Abfrage für Informationen
      axios
        .get(
          // `http://fahrplan.sbb.ch/bin/stboard.exe?input=8503104&L=vs_java3&boardType=dep&start=yes&disableEquivs=1&maxJourneys=11`,
          `https://fahrplan.baertschi.one/stboard?input=8503104&L=vs_java3&boardType=dep&start=yes&disableEquivs=1&maxJourneys=11`
        )
        .then((res) => {
          console.log(res);
          const sbbrespose = res.data;

          var json = parser.xml2json(sbbrespose);
          // console.log(json.Journey);
          var journeys = json.Journey;

          journeys = this.processData(journeys);

          this.setState({ journeys });
        })
        .catch((error) => {
          console.log(error);
        });
    };

    processData = (journeys) => {
      //journeys.map macht es das es Loopt
      return journeys.map((journey) => {
        console.log(
          "################# Verarbeite Zug " +
            journey.prod +
            " #################"
        );

        if (journey.delay !== "" && journey.delay !== "-") {
          // zug hat verspätung oder ausfall
          if (journey.delay === "cancel") {
            // Zug ist ausgefallen
            journey.iscancel = true;
          } else {
            // Zug hat Verspätung
            journey.isDelayed = true;

            if (journey.e_delay !== "") {
              //    console.log("verspätung: 22:23 +" + journey.e_delay + "'");
              journey.delayInMin = journey.e_delay;
            } else {
              //    console.log("verspätung d " + journey.e_delay);
              journey.delayInMin = journey.delay;
            }
          }
        }
        // ist nicht "" oder "-"
        //      ist "cancel"
        //          -> zug ausfall !
        //      sonst
        //           wenn feld edelay nicht ""
        //              -> verspätung edelay
        //          sonst
        //              verstätung delay

        // TODO:
        // Message Header & Message Body Darstellen
        // capacity anzeigen -> "1|2" an zeichen | aufteilen = 1.Klasse und 2.Klasse (wert zwischen 0-3)
        //tabbele machen

        //let l = journey.HIMMessage.lead;
        //console.log(l);

        //ausfall von Zug, Nachrichten zusammen verbinden
        if (journey.HIMMessage === undefined) {
          //console.log("");
        } else {
          var leadStringVariable = journey.HIMMessage.lead;
          var hederStringVariable = journey.HIMMessage.header;

          var decodedleadStringVartiable = he.decode(leadStringVariable);
          var decodedHeaderStringVariable = he.decode(hederStringVariable);

          // console.log(decodedleadStringVartiable);
          // console.log(decodedHeaderStringVariable);

          // console.log(he.decode(journey.HIMMessage.lead));

          journey.cleanMassage = decodedleadStringVartiable;
          journey.cleanMassageTitel = decodedHeaderStringVariable;

          // console.log(leadStringVariable);
          // console.log(hederStringVariable);
          // var q = stringzusammenfügen(
          //   journey.HIMMessage.header,
          //   journey.HIMMessage.lead
          // );
          // console.log(q);
        }

        //1.Klasse und 2.Klasse aufteilen
        let c = journey.capacity.split("|");
        journey.firstclass = c[0];
        journey.secondclass = c[1];

        //Umlaute werden übersetzt
        journey.dir = he.decode(journey.dir);

        return journey;
      });
    };

    componentDidMount() {
      startTime(); // Start Clock
      this.getData(); // Load Data
      setInterval(this.getData, 60000); // runs every 60 seconds.
    }

    showOfflineData = () => {
      if (this.online) {
        this.online = false;
        console.log("going offline");

        // load Explame data and update state
        var json = parser.xml2json(example);
        var journeys = json.Journey;
        journeys = this.processData(journeys);

        this.setState({ journeys });
      } else {
        console.log("going online");
        this.online = true;
        this.getData();
      }
    };

    //abfragen Parameter
    render() {
      console.log("state:", this.state);
      return (
        <div>
          <table className="tabletitel">
            <tbody>
              <tr>
                <th className="Bahnhof">Bahnhof Meilen</th>
                <th
                  className="Uhr"
                  id="clock"
                  onClick={() => this.showOfflineData()}
                ></th>
              </tr>
            </tbody>
          </table>
          <table>
            <tbody>
              {this.state.journeys.map((journey) => (
                <TimetableEntry journey={journey} />
              ))}
            </tbody>
          </table>
        </div>
      );
    }
  }
);

//ausfall von Zug, Nachrichten zusammen verbinden
// function stringzusammenfügen(Titel, Inhalt) {
//   var Resultat = Titel + " " + Inhalt;
//   var Resfix = he.decode(Resultat);
//   return Resfix;
// }



// WEBPACK FOOTER //
// ./src/timetable.js